<template>
  <div 
    class="row d-flex justify-content-between align-items-center"
  >
    <div class="row justify-content-between">
      <a class="h5" href="javascript:void(0)"
        @click="onClick"
      >
        <i class="uil-arrow-left ml-3" style="font-size: 20px;"></i> 
        Company Details
      </a>
    </div>
    <div class="justify-content-center col-md-12 text-left" style="height: 1024px;">
      <div class="row col-12 mt-3">
        <div class="col-2 px-0 media">
          <Avatar 
            :data="company" 
            customClass="avatar-lg rounded" 
            alt="avatar"
          />
        </div>
        <div class="col-10 pl-0">
          <h6 class="font-weight-normal">Industry: {{ company.industry_id | formattedIndustry }}</h6>
          <h4 class="mt-1 mb-1" style="color: #333333;"><strong>{{ company.name || '-' }}</strong></h4>
          <h6 class="font-weight-normal">Foreign Employement: {{ company.is_non_japanese_hiring ? 'Yes' : 'No' }} | {{ company.country ? company.city + ', ' + company.country : company.city }}</h6>
        </div>
      </div>
      <!-- <div class="row mt-2" >
        <div class="col-4">Company Establishment</div>
        <div class="col-4">Staff</div>
      </div>
      <div class="row mt-1">
        <div class="col-4">September, 1998</div>
        <div class="col-4">Li Europan lingues</div>
      </div> -->

      <h5 class="mt-5 mb-1" style="color: #333333;"><strong>About</strong></h5>
      <div class="col-12 pt-4 description_container">
        <span v-if="company.remarks" v-html="company.remarks"></span>
        <span style="font-size: 12px;" v-else>No description(s) available</span>
      </div>

      <h5 class="mt-5 mb-1" style="color: #333333;"><strong>Address</strong></h5>
      <div class="ml-2 mt-4">
        <span style="font-size: 12px;">{{ company.complete_address }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import Avatar from '@components/avatar'
export default {
  components: {
    Avatar
  },
  props: {
    parameters: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    company() {
      let parameters = this.parameters || {}
      return parameters.candidateCompany || {}
    },
  },
  methods: {
    onClick() {
      this.$emit('onClick')
    }
  },
  filters: {
    formattedIndustry(val){
      let name = []
      for(let key in val){
        name.push(val[key].name)
      }

      return name.join(', ') || "-"
    }
  },
}
</script>
<style>
.body-content {
  position: absolute;
  width: 471px;
  height: 422px;
  left: 909px;
  top: 301px;
}
.custom-image {
  position: absolute;
  width: 120px;
  height: 120px;
  /* left: calc(50% - 120px/2 + 425px); */
  top: calc(50% - 120px/2 - 151px);

  /* Gray 4 */

  background: #BDBDBD;
}

.text-line {
  width: 100%; 
  text-align: center; 
  border-bottom: 1px solid #000; 
  line-height: 0.1em;
  margin: 10px 0 20px; 
}   

.text-line span { 
  background:#ffffff;
  padding:0 10px; 
}

</style>